import gsap from 'gsap';
import { Sprite } from 'pixi.js';

import { Shared } from '../App';
import { Maths } from '../utils/Maths';
import { Widget } from './Widget';

export class TrafficLightsWidget extends Widget
{
    public sprite: Sprite;
    public state = 1;
    private timeout: any;

    constructor()
    {
        super();
        this.sprite = new Sprite();
        this.sprite.anchor.set(0.5, 0.15);
        this.view.addChild(this.sprite);
    }

    public refresh(): void
    {
        if (!this._opened) return;
        this.sprite.texture = Shared.assets.getTexture(`countdown-state${this.state}`);
    }

    public setState(state: number): void
    {
        this.state = Maths.clamp(state, 1, 5);
        this.refresh();

        // Auto hide after last state
        if (state === 5) this.timeout = setTimeout(() => this.close(), 700);
    }

    protected async onOpen(): Promise<void>
    {
        clearTimeout(this.timeout);
        this.timeout = undefined;
        gsap.killTweensOf(this.sprite);
        this.setState(1);
        this.sprite.y = -400;
        this.sprite.updateTransform();
        await gsap.to(this.sprite, { duration: 0.3, y: 0, ease: 'back.out' });
    }

    protected async onClose(): Promise<void>
    {
        clearTimeout(this.timeout);
        this.timeout = undefined;
        gsap.killTweensOf(this.sprite);
        await gsap.to(this.sprite, { duration: 0.3, y: -400, ease: 'back.in' });
    }
}
